import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CashbackOfferFilterEntity } from '../../domain/entities/CashbackOfferFilterEntity'

export class CashbackFilterModel extends CashbackOfferFilterEntity {
  startDate?: string
  endDate?: string
  branchId?: number

  constructor(dataDto: CashbackOfferFilterEntity) {
    super()
    mapEntityProperties<CashbackFilterModel>(this, dataDto, {
      exclude: ['dateRange', 'branch', 'region'],
      map: {
        startDate: dataDto.dateRange?.[0],
        endDate: dataDto.dateRange?.[1],
        branchId: dataDto.branch?.id,
        regionId: dataDto.region?.id ?? dataDto.regionId
      }
    })
  }
}
